import { parseApiUrl, parseOrderBy, parseFilters, handleError, storeMixin, storeGenerator, parseForm } from '@/storeMixin'
import { merge } from 'lodash'
import { axiosThux } from '@/axiosThux'

const notification = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/notify/{profile}/notification',
    expiringTasksApiUrl: '/api/v1/notify/{profile}/expiring-tasks',
    tasksNotificationApiUrl: '/api/v1/notify/{profile}/notification/my-task-notification',
    expiringTasksCount: 0,
    expiringTasksList: [],
    tasksNotificationList: [],
    tasksNotificationCount: 0,
    app: 'notify'
  },
  mutations: {
    setExpiringTasks (state, payload) {
      state.expiringTasksCount = (payload && payload.count) || 0
      state.expiringTasksList = (payload && payload.results) || []
    },
    setTasksNotification (state, payload) {
      state.tasksNotificationCount = (payload && payload.length) || 0
      state.tasksNotificationList = payload || []
    }
  },
  getters: {
    expiringTasksCount: state => state.expiringTasksCount,
    expiringTasksList: state => state.expiringTasksList,
    tasksNotificationCount: state => state.tasksNotificationCount,
    tasksNotificationList: state => state.tasksNotificationList
  },
  actions: {
    async getExpiringTasks ({ state, commit, dispatch }, payload = {}) {
      const days = payload.days || 2
      const url = `${parseApiUrl(this, state.expiringTasksApiUrl)}/?days=${days}`
      return axiosThux.get(url)
        .then(response => {
          commit('setExpiringTasks', response.data)
          return response.data
        }).catch(error => {
          handleError(commit, dispatch, error)
        })
    },
    async getTasksNotification ({ state, commit, dispatch }, payload = {}) {
      const url = `${parseApiUrl(this, state.tasksNotificationApiUrl)}/?no_page=no_page`
      return axiosThux.get(url)
        .then(response => {
          commit('setTasksNotification', response.data)
          return response.data
        }).catch(error => {
          handleError(commit, dispatch, error)
        })
    },
    async getList ({ state, commit, getters, dispatch }) {
      let url = `${parseApiUrl(this, state.apiUrl)}/my-downloads/?`
      url = `${url}${getters.perPage ? 'per_page=' + getters.perPage : ''}`
      url = `${url}${getters.page ? '&page=' + getters.page : ''}`
      url = `${url}${
        getters.orderBy ? '&order_by__=' + getters.orderBy : ''
      }`
      url = parseOrderBy(getters, url)
      url = parseFilters(getters, url)
      return axiosThux.get(url)
        .then(response => {
          commit('setList', response.data)
          commit('setPerPage', response.data.per_page)
        }).catch(error => {
          handleError(commit, dispatch, error)
        })
    },
    async setRead ({ state, commit, dispatch }, data) {
      const url = `${parseApiUrl(this, state.apiUrl)}/${data.id}/read/?`
      return axiosThux.post(url, parseForm(data))
        .then(
          response => {
            dispatch('notifySuccess', { title: '', text: this._vm.$t('Data has been saved successfully') }, { root: true })
          }
        ).catch(error => {
          handleError(commit, dispatch, error)
        })
    }

  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      {
        profile: 'GENERIC',
        app: 'notify',
        model: 'notification'
      }
    ),
    {
      GENERIC: {
        notify: {
          notification: {
            DETAIL: {
              ACTIONS: {
                setRead: 'GENERIC/notify/notification/setRead',
                getExpiringTasks: 'GENERIC/notify/notification/getExpiringTasks',
                getTasksNotification: 'GENERIC/notify/notification/getTasksNotification'
              },
              GETTERS: {
                expiringTasksCount: 'GENERIC/notify/notification/expiringTasksCount',
                expiringTasksList: 'GENERIC/notify/notification/expiringTasksList',
                tasksNotificationCount: 'GENERIC/notify/notification/tasksNotificationCount',
                tasksNotificationList: 'GENERIC/notify/notification/tasksNotificationList'
              }
            }
          }
        }
      }

    }
  )
)()

export { notification, TYPES }
